import { render, staticRenderFns } from "./load-resource-modal.vue?vue&type=template&id=661bb62c&scoped=true"
import script from "./load-resource-modal.vue?vue&type=script&lang=js"
export * from "./load-resource-modal.vue?vue&type=script&lang=js"
import style0 from "./load-resource-modal.vue?vue&type=style&index=0&id=661bb62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661bb62c",
  null
  
)

export default component.exports